import { Component, OnInit, Renderer2, ViewChild, ElementRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { global } from '../../shared/global';
import { SocketclientService } from '../socketclient.service';
import { JsonpClientBackend } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { CreateshopService } from '../createshop/createshop.service';
import { WalkInModel, TokenInModel } from '../Models/shopkeeper.model';
declare var $: any;

@Component({
  selector: 'app-shopkeeper',
  templateUrl: './shopkeeper.component.html',
  styleUrls: ['./shopkeeper.component.css']
})
export class ShopkeeperComponent implements OnInit {
  @ViewChild('walkInForm', { static: true }) walkInForm: NgForm;
  @ViewChild('tokenInForm', { static: true }) tokenInForm: NgForm;

  @ViewChild('divSerConn', { static: true }) divSerConn: ElementRef;

  @ViewChild('custName', { static: true }) walkInCustName: ElementRef;
  @ViewChild('custMobile', { static: true }) walkInCustMobile: ElementRef;
  @ViewChild('custAdd', { static: true }) walkInCustAdd: ElementRef;

  data: any;
  cookieValue: any;
  name: any;
  stickerLink: any;
  errorMessage: any;

  configCookie: any;
  staffCookie: any;

  serverMessage: string = "";
  serverSignal: string = "";

  currentToken: any;
  waitingToken: any;
  activeTokenList: any;
  termConditionLink: any;

  shopkeeperTitle: any;
  shopkeeperData: any;

  tokenDisplayName: any;

  walkInData: WalkInModel;
  tokenInData: TokenInModel;

  constructor(private cookieService: CookieService, private sw: SocketclientService, private router: Router, private service: CreateshopService,
    private renderer: Renderer2) {
    this.sw.WebSocketMessage().subscribe(data => {
      this.onReceive(data);
    });

    this.sw.WebSocketConnected().subscribe(() => {
      this.onOpen();
    });

    this.sw.WebSocketDisconnected().subscribe(() => {
      this.onClose();
    });

    this.configCookie = this.cookieService.get("config");
    this.cookieValue = this.cookieService.get("shop");
    this.staffCookie = this.cookieService.get("staff");

    if (this.configCookie) {
      this.configCookie = JSON.parse(this.configCookie);

      if (this.configCookie.isStaff == 1) {
        if (this.staffCookie) {
          var staffData = JSON.parse(this.staffCookie);
          var str = { "company_id": staffData.companyid, "asccode": staffData.asccode, "usertype": "info" };
          this.sw.send(JSON.stringify(str));
        }
      } else {
        if (this.cookieValue) {
          var cookieData = JSON.parse(this.cookieValue);
          var str = { "company_id": cookieData.companyid, "asccode": cookieData.asccode, "usertype": "info" };
          this.sw.send(JSON.stringify(str));
        }
      }
    }
  }

  onOpen() {
    if (this.cookieValue) {
      console.log("Wesocket Connected");
      document.getElementById("serConn").innerText = "Server Connected!";
      document.getElementById("serConn").style.color = "green";
      // const span: HTMLParagraphElement = this.renderer.createElement('span');
      // span.setAttribute("style", "height: 25px; width: 25px; background-color:green; border-radius: 50%; display: inline-block;");
      // this.renderer.appendChild(this.divSerConn.nativeElement, span);
    }
  }

  onClose() {
    if (this.cookieValue) {
      console.log("Wesocket Not Connected");
      document.getElementById("serConn").innerText = "Server Not Connected!";
      document.getElementById("serConn").style.color = "red";
      // const span: HTMLParagraphElement = this.renderer.createElement('span');
      // span.setAttribute("style", "height: 25px; width: 25px; background-color:red; border-radius: 50%; display: inline-block;");
      // this.renderer.appendChild(this.divSerConn.nativeElement, span);
    }
  }

  onReceive(Data) {
    const msg = JSON.parse(Data);
    // console.log(msg);
    if (msg.usertype == "currenttoken") {
      if (msg.isSuccess) {
        // this.currentToken = msg.CurrentActive
        // this.waitingToken = msg.before;

        this.currentToken = msg.activecount;
        this.waitingToken = msg.before;
        this.activeTokenList = msg.activelist;
      } else {
      }
    }

    if (msg.usertype == "active") {
      if (msg.isSuccess) {
        // this.currentToken = msg.CurrentActive
        // this.waitingToken = msg.before;

        this.currentToken = msg.CurrentActive;
        this.waitingToken = msg.before;
        this.activeTokenList = msg.activelist;
      } else {
      }
    }
  }

  ngOnInit() {
    this.walkInData = new WalkInModel();
    this.tokenInData = new TokenInModel();

    this.tokenDisplayName = "Persons Inside";
    this.termConditionLink = global.termConditionLink;

    this.configCookie = this.cookieService.get("config");
    this.cookieValue = this.cookieService.get("shop");
    this.staffCookie = this.cookieService.get("staff");

    if (this.configCookie) {
      this.configCookie = JSON.parse(this.configCookie);

      if (this.configCookie.isStaff == 1) {
        if (this.staffCookie) {

          this.staffCookie = JSON.parse(this.staffCookie);

          this.data = this.staffCookie;
          // console.log(this.data);

          document.getElementById("divContextVendor").style.display = "none";
          document.getElementById("divContextStaff").style.display = "block";

          document.getElementById("divVendor").style.display = "none";

          this.shopkeeperTitle = this.data.companyname;
          this.stickerLink = global.getStickerUrl + this.data.asccode;

          if (this.staffCookie.role == 'in') {
            document.getElementById("divBtnIn").style.display = "block";
            document.getElementById("divBtnWalkIn").style.display = "block";
          }
          if (this.staffCookie.role == 'out') {
            document.getElementById("divBtnOut").style.display = "block";
          }
          if (this.staffCookie.role == 'inout' || this.staffCookie.role == '') {
            document.getElementById("divBtnIn").style.display = "block";
            document.getElementById("divBtnWalkIn").style.display = "block";
            document.getElementById("divBtnOut").style.display = "block";
          }
          if (this.staffCookie.role == 'walkin') {
            document.getElementById("divBtnWalkIn").style.display = "block";
            document.getElementById("divTokenArea").style.display = "none";
          }
          if (this.staffCookie.role == 'next') {
            this.tokenDisplayName = "Active Token";
            document.getElementById("divBtnNext").style.display = "block";
          }
        } else {
          this.router.navigate(["/welcome"]);
        }
      } else {
        document.getElementById("divContextVendor").style.display = "block";
        document.getElementById("divContextStaff").style.display = "none";

        document.getElementById("divVendor").style.display = "block";

        document.getElementById("divBtnIn").style.display = "block";
        document.getElementById("divBtnWalkIn").style.display = "block";
        document.getElementById("divBtnOut").style.display = "block";

        if (this.cookieValue) {
          this.name = "Manage Entity";
          document.getElementById("divManage").style.display = "block";
          // document.getElementById("divChat").style.display = "block";

          this.data = JSON.parse(this.cookieValue);

          var compData = {
            "companyid": this.data.companyid
          }

          this.service.getShopInfo(compData)
            .subscribe(shopData => {
              this.shopkeeperData = shopData;

              if (this.shopkeeperData.isSuccess == false) {
              }
              else {
                this.shopkeeperTitle = this.shopkeeperData.data.name;
              }
            });

          this.stickerLink = global.getStickerUrl + this.data.asccode;
        }
        else {
          this.name = "Create Entity";
          this.shopkeeperTitle = "";
          document.getElementById("divManage").style.display = "none";
          // document.getElementById("divChat").style.display = "none";
        }
      }
    }
  }

  createShop() {
    if (this.cookieValue) {
      this.router.navigate(["/createshop"]);
    } else {
      this.router.navigate(["/entitylogin"]);
    }
  }

  tokenIn() {
    if(this.data.customer_register == '') {
      this.data.customer_register = 0;
    }
    
    if (this.data.customer_register == 1) {
      $('#tokenInModal').modal('show');
    } else {
      var inRequest = { "company_id": this.data.companyid, "asccode": this.data.asccode, "active_abbr": "ALL", "usertype": "in", "counter": "1", "value": "true" };
      this.sw.send(JSON.stringify(inRequest));
    }
  }

  tokenWalkIn() {
    if(this.data.customer_register == '') {
      this.data.customer_register = 0;
    }

    if (this.data.customer_register == 1) {
      $('#walkInModal').modal('show');
    } else {
      var walkInRequest = { "company_id": this.data.companyid, "asccode": this.data.asccode, "active_abbr": "ALL", "usertype": "walkin", "counter": "1", "value": "true" };
      this.sw.send(JSON.stringify(walkInRequest));
    }
  }

  tokenOut() {
    var outRequest = { "company_id": this.data.companyid, "asccode": this.data.asccode, "active_abbr": "ALL", "usertype": "out", "counter": "1", "value": "true" };
    this.sw.send(JSON.stringify(outRequest));
  }

  logout() {
    if (this.configCookie.isStaff == 1) {
      this.cookieService.delete("staff");
    } else {
      this.cookieService.delete("shop");
    }
    this.cookieService.delete("config");
    this.router.navigate(["/login"]);
  }

  callToken() {
    var nextRequest = { "company_id": this.data.companyid, "asccode": this.data.asccode, "active_abbr": "ALL", "usertype": "active", "counter": "1", "value": "true" };
    this.sw.send(JSON.stringify(nextRequest));
    console.log(nextRequest);
  }

  cancelWalkIn() {
    $('#walkInModal').modal('hide');
    this.walkInForm.resetForm();
  }

  submitWalkIn(walkin: WalkInModel) {
    if (this.walkInForm.valid) {
      var walkInRequest = { "company_id": this.data.companyid, "asccode": this.data.asccode, "name": walkin.custName, "mobile": walkin.custMobile, "address": walkin.custAdd, "active_abbr": "ALL", "usertype": "walkin", "counter": "1", "value": "true" };
      this.sw.send(JSON.stringify(walkInRequest));
      $('#walkInModal').modal('hide');
      this.walkInForm.resetForm();
    }
  }

  cancelTokenIn() {
    $('#tokenInModal').modal('hide');
    this.tokenInForm.resetForm();
  }

  submitTokenIn(tokenin: TokenInModel) {
    if (this.tokenInForm.valid) {
      var inRequest = { "company_id": this.data.companyid, "asccode": this.data.asccode, "token": tokenin.tokenNumber, "active_abbr": "ALL", "usertype": "in", "counter": "1", "value": "true" };
      this.sw.send(JSON.stringify(inRequest));
      $('#tokenInModal').modal('hide');
      this.tokenInForm.resetForm();
    }
  }
}
